interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  actionLabel,
  onAction,
}: SectionHeadingProps) {
  return (
    <div className="mb-6 flex flex-wrap items-end justify-between gap-3">
      <div>
        {eyebrow ? (
          <span className="font-label mb-2 inline-flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wider text-accent-600">
            <span className="h-1 w-1 rounded-full bg-accent-500" />
            {eyebrow}
          </span>
        ) : null}
        <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">{title}</h2>
        {description ? <p className="mt-1.5 text-sm text-foreground-600">{description}</p> : null}
      </div>
      {actionLabel && onAction ? (
        <button
          type="button"
          onClick={onAction}
          className="font-label group inline-flex cursor-pointer items-center gap-1 whitespace-nowrap rounded-md border border-background-300/70 bg-background-50 px-3.5 py-2 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:bg-primary-50 hover:text-primary-700"
        >
          {actionLabel}
          <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" />
        </button>
      ) : null}
    </div>
  );
}